import errorTypes from '../../enums/errorTypes'
import KitFitError from './KitFitError'
import that from '../translationHelper'

const unknownErrorMessage = that.context.translate('Unknown error')

export const getErrorType = error => (error instanceof KitFitError ? error.type : errorTypes.UNKNOWNERROR)
export const isErrorOfType = (error, type) => getErrorType(error) === type

export const isLocalisedError = error => error instanceof KitFitError && error.type === errorTypes.LOCALISEDERROR
export const getLocalisedMessage = (error, defaultMessage = unknownErrorMessage) => (isLocalisedError(error) ? error.message : defaultMessage)

export const errorOfType = (type, ...details) => {
	if (!errorTypes[type]) {
		console.error('Invalid error type', type, ...details)
	}
	return new KitFitError(errorTypes[type], type, ...details)
}

export const customError = (message, ...details) => new KitFitError(message, errorTypes.CUSTOMERROR, ...details)
export const localisedError = (message, ...details) => new KitFitError(message, errorTypes.LOCALISEDERROR, ...details)

export const pretty = value => (typeof value === 'object' ? JSON.stringify(value, null, 4) : value)

export const logError = (message, error) => {
	console.groupCollapsed(`%c${message}`, 'color: #f55;')
	console.log(error)
	console.log('%O', error)
	console.groupEnd()
}

export { errorTypes }



// WEBPACK FOOTER //
// ./src/utilities/Errors/index.js